var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHuppaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 526.359,
    height: 96.253,
    viewBox: "0 0 526.359 96.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HUPPA_Logo_Screen_White_RGB",
    transform: "translate(0 -0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1627.146,60.415a11.692,11.692,0,0,1-.181-2.278c-.014-6.67.17-13.345-.074-20a54.673,54.673,0,0,0-1.546-12.287,30.035,30.035,0,0,0-13.888-18.173c-7.037-4.88-17.5-7.662-32.843-7.662-36.051,0-50.2,13.74-50.2,34.444,0,2.445.189,4.894.378,7.152h38.126a28.592,28.592,0,0,1-.189-3.388c0-5.264,2.308-8.227,7.3-8.891a17.629,17.629,0,0,1,2.328-.143c6.607,0,9.436,3.575,9.436,9.6v7.528h-30.765c-21.329,0-29.443,10.541-29.443,24.092,0,11.857,6.607,25.6,31.143,25.6.187,0,.37,0,.554,0a42.956,42.956,0,0,0,5.71-.337c.255-.03.5-.06.754-.093a37.213,37.213,0,0,0,6.52-1.426.087.087,0,0,0,.025-.008,21.542,21.542,0,0,0,11.193-7.227,25.568,25.568,0,0,0,4.732-10.716,32.911,32.911,0,0,0,.984-7.89h2.215c0,.757-.039,1.4.005,2.04.187,2.717.208,5.464.636,8.145.041.255.088.5.135.754,1.933,10.322,8.863,14.974,17.633,16.125,7.279.957,14.683,1.064,21.573-1.9,1.521-.652,3.019-1.4,4.315-2.012l-.044-28.87c-2.393,1.08-6,.389-6.519-2.166Zm-41.355-3.3c-.189,6.588-4.529,10.541-10.758,10.541-4.907,0-7.928-2.635-7.928-6.963s2.453-6.4,8.115-6.4h10.568v2.824Z",
    transform: "translate(-1107.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1244.193,6.316a53.746,53.746,0,0,0-19.941-3.526H1170.9V97.275h37.473V78.444c5.511,0,10.785-.022,16.057.005,6.974.036,13.833-.661,20.339-3.361,8.578-3.558,14.738-9.518,17.641-18.472a49.887,49.887,0,0,0-.378-31.642c-2.944-8.94-9.031-15.155-17.839-18.658Zm-17.715,34.51v7.55H1207.6v-7.55c0-6.039,2.832-9.625,9.436-9.625s9.436,3.586,9.436,9.625Z",
    transform: "translate(-849.902 -2.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M446.912,43.97v7.55c0,6.039-2.832,9.625-9.436,9.625s-9.436-3.586-9.436-9.625V2.76l-43.789.005V63.453c0,23.938,10.346,34.806,31.93,34.806,18.908,0,26.809-9.691,30.2-25.389h2.086c-.178,10.2-.535,18.689-.891,24.377H490.74V2.768l-43.825-.005v41.21Z",
    transform: "translate(-278.909 -1.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M58.251,31.2H39.376V2.79H0V97.255H39.376V74.131l.014-3.58c.077-5.891,2.917-9.381,9.433-9.381s9.184,3.284,9.42,8.858v4.107h.008V97.258H97.626V2.79H58.251V31.2Z",
    transform: "translate(0 -2.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M873.543,6.316A53.747,53.747,0,0,0,853.6,2.79H800.25V97.275h37.473V78.444c5.51,0,10.785-.022,16.057.005,6.974.036,13.833-.661,20.339-3.361,8.578-3.558,14.738-9.518,17.641-18.472a49.886,49.886,0,0,0-.378-31.642c-2.944-8.94-9.03-15.155-17.839-18.658ZM855.825,40.532v7.55H836.95v-7.55c0-6.039,2.832-9.625,9.436-9.625s9.436,3.586,9.436,9.625Z",
    transform: "translate(-580.864 -2.018)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuppaLogo);
export default __webpack_public_path__ + "static/media/huppa_logo.b6ca5490b5f7abd013b6dbd37370ce25.svg";
export { ForwardRef as ReactComponent };